import React, { PropsWithChildren } from 'react';

type Option = PropsWithChildren &
  React.DetailedHTMLProps<React.OptionHTMLAttributes<HTMLOptionElement>, HTMLOptionElement>;

export function Option({ children, ...optionProps }: Option) {
  return (
    <option className="form2-select__option" {...optionProps}>
      {children}
    </option>
  );
}
